import GlobalStore from "../../store/GlobalStore";
import {config} from '../../config.js';

const API_BASE_URL = 'https://hammasoskari-proxy.herokuapp.com/https://appointment.assiscare.com/api/oskari';

class ApiConnector {

    static getCategory() {
        return fetch(`${API_BASE_URL}/reasons/groups`)
            .then((response) => {
                if (response.ok) {
                    return response.json()
                } else {
                    return response;
                }
            })
    }

    static getSubCategory(parent_id) {
        return fetch(`${API_BASE_URL}/reasons/group/${parent_id}`)
            .then((response) => response.json())
            .then(data => {
                return data;
            });
    }

    static getOffices(reason_id) {
        return fetch(`${API_BASE_URL}/branches/reason/${reason_id}`)
            .then((response) => response.json())
            .then(data => {
                return data;
            });
    }

    static getDoctorsList(currentSubCategoryId, currentOfficeId) {

        let branchFilterURLParamString = "";
        if (currentOfficeId === "all") {
            branchFilterURLParamString = ""
        } else {
            branchFilterURLParamString = "&branchId="+currentOfficeId;
        }

        return fetch(`${API_BASE_URL}/employees/filter?reasonId=${currentSubCategoryId}${branchFilterURLParamString}`)
            .then((response) => response.json())
            .then(data => {
                return data;
            });
    }

    static getTimeList(currentSubCategoryId, currentDate, lastHourCurrentDate, filterDoctorId, resultType, currentOfficeId) {
        let doctorFilterURLParamString = "";
        if (filterDoctorId === undefined || filterDoctorId === "") {
            doctorFilterURLParamString = ""
        } else {
            doctorFilterURLParamString = "&personIds="+filterDoctorId;
        }

        let branchFilterURLParamString = "";
        if (currentOfficeId === "all") {
            branchFilterURLParamString = ""
        } else {
            branchFilterURLParamString = "&branchIds="+currentOfficeId;
        }

       return fetch(`${API_BASE_URL}/availabletimes?reasonId=${currentSubCategoryId}${branchFilterURLParamString}${doctorFilterURLParamString}&startDate=${currentDate}&endDate=${lastHourCurrentDate}&resultType=${resultType}`)
            .then((response) => response.json())
            .then(data => {
                if (resultType === 'Full') {
                    return data.Slots;
                } else {
                    return data.Days;
                }
            });
    }

    static getUserBySSN(userName, userSurname, userSSN, userPhone) {
        return fetch(`${API_BASE_URL}/patients/canbook/${userSSN}/${userName}/${userSurname}`)
            .then((response) => {
                return response;
            });
    }

    static registrationUserBySSN(userName, userSurname, personalPhone, userSSN) {
        return fetch(`${API_BASE_URL}/patients/`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                Person: {
                    SSN: userSSN,
                    FirstName: userName,
                    PhoneNumber: personalPhone,
                    LastName: userSurname
                },
                RecompenseClass: "KelaRecompense"
            })
        })
    }

    static createNewBooking() {
        if (config.environment !== "prod") {
            //debugging the final booking request in dev environment:
            console.log(JSON.stringify({
                Reminders: [],
                ReminderDays: GlobalStore.getInstance().data['remindersArray'],
                StartTime: GlobalStore.getInstance().data['stepTimeData'].StartTime,
                EndTime: GlobalStore.getInstance().data['stepTimeData'].EndTime,
                Title: "",
                Description: "",
                // PatientId: GlobalStore.getInstance().data['userFullData'].Id,
                PatientFirstName: GlobalStore.getInstance().data['userShortData'].userName,
                PatientLastName: GlobalStore.getInstance().data['userShortData'].userSurname,
                PatientSSN: GlobalStore.getInstance().data['userShortData'].userSSN,
                PatientState: "Initial",
                ReminderPhoneNumber: GlobalStore.getInstance().data['userShortData'].personalPhone,
                Status: "Reserved",
                Type: "PatientAppointmentReservedFromInternet",
                PatientLanguage: "fi",
                PatientInfo: null,
                DoctorId: GlobalStore.getInstance().data['stepTimeData'].ResourceId,
                ReasonId: GlobalStore.getInstance().data['stepTimeData'].ReasonId,
                BranchId: GlobalStore.getInstance().data['stepTimeData'].BranchId,
                SendEmailConfirmation: true,
                SendSmsConfirmation: true
            }));
            let fakeResponse = {
                "ok": true,
                "Id": "4d3b7a31-6dd2-4f4b-b001-bb0ee6ac311c",
                "StartTime": "2099-99-99T08:00:00",
                "EndTime": "2099-99-99T08:15:00",
                "Title": "Fake Response",
                "Description": null,
                "PatientInfo": null,
                "BranchId": "5f7320be-14d7-4723-848a-582092ecd1a1",
                "PatientId": "ec839e76-d838-4328-b8b8-ac55e04b1249",
                "DoctorId": "06ab2c60-d1ca-44ac-9df8-707d033dc032",
                "ReasonId": "3cf756d7-8df1-464b-b4d7-41bc1d2a0b43",
                "PrimaryColorId": 0,
                "SecondaryColorId": 0,
                "Reminders": [
                    "TwoHoursBefore",
                    "OneDayBefore"
                ],
                "Status": "Reserved",
                "Type": "PatientAppointmentReservedFromInternet",
                "PatientState": "Initial",
                "IsMoved": false,
                "ExternalId": "AN2Z5WJMR",
                "Created": "2018-11-20T17:38:17.2715887",
                "Modified": "2018-11-20T17:38:17.2715887"
            };
            GlobalStore.getInstance().data['FakeResponse'] = true; //to remember as developer that this response is fake
            return Promise.resolve(fakeResponse);

        } else {
            return fetch(`${API_BASE_URL}/appointments/patientname`, { //https://appointment.assiscare.com/api/oskari/appointments/patientname
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    Reminders: [],
                    ReminderDays: GlobalStore.getInstance().data['remindersArray'],
                    StartTime: GlobalStore.getInstance().data['stepTimeData'].StartTime,
                    EndTime: GlobalStore.getInstance().data['stepTimeData'].EndTime,
                    Title: "",
                    Description: "",
                    // PatientId: GlobalStore.getInstance().data['userFullData'].Id,
                    PatientFirstName: GlobalStore.getInstance().data['userShortData'].userName,
                    PatientLastName: GlobalStore.getInstance().data['userShortData'].userSurname,
                    PatientSSN: GlobalStore.getInstance().data['userShortData'].userSSN,
                    PatientState: "Initial",
                    ReminderPhoneNumber: GlobalStore.getInstance().data['userShortData'].personalPhone,
                    Status: "Reserved",
                    Type: "PatientAppointmentReservedFromInternet",
                    PatientLanguage: "fi",
                    PatientInfo: null,
                    DoctorId: GlobalStore.getInstance().data['stepTimeData'].ResourceId,
                    ReasonId: GlobalStore.getInstance().data['stepTimeData'].ReasonId,
                    BranchId: GlobalStore.getInstance().data['stepTimeData'].BranchId,
                    SendEmailConfirmation: true,
                    SendSmsConfirmation: true
                })
            })
        }


    }

    static updateUserInformation(userFullData) {
        return fetch(`${API_BASE_URL}/patients/${GlobalStore.getInstance().data['userFullData'].Id}/`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                Id: GlobalStore.getInstance().data['userFullData'].Id,
                Person: {
                    Id: GlobalStore.getInstance().data['userFullData'].Id,
                    FirstName: GlobalStore.getInstance().data['userShortData'].userName,
                    LastName: GlobalStore.getInstance().data['userShortData'].userSurname,
                    PhoneNumber: userFullData.personalPhone,
                    EmailAddress: userFullData.personalEmail,
                    SSN: GlobalStore.getInstance().data['userShortData'].userSSN,
                    Address: {
                        Street: userFullData.personalStreetName,
                        City: userFullData.personalCity,
                        PostalCode: userFullData.personalZipCode
                    }
                },
                RecompenseClass: "KelaRecompense"
            })
        })
            .then(response => {
                return response;
            })
    }

}

export default ApiConnector;


// WEBPACK FOOTER //
// ./src/components/api/ApiConnector.jsx